/* =====================================================================
   blend kyoto - renewal : page transition
   全ページ共通の「継ぎ目のない」ページ遷移。サイト内リンクを原則すべて
   対象にする(オプトアウト方式。除外は isExcludedLink を参照)。

   離脱(リンククリック):
     1) アクセントカラー(--bk-accent)の面が左→右にワイプして画面を覆う
        ※商品カード等 data-bk-theme を持つ要素はその色を使う
     2) 基本背景色(--bk-bg = #e5e5e5)の面が左→右にワイプして覆う
     3) 覆われたまま次ページへ遷移(旧ページは覆われたまま)

   侵入(次ページ表示):
     遷移直前(base面)と直後のページ地色は同じ #e5e5e5 なので、つなぎの機構は不要。
     中身のフェードインは bk-animations.js のページ エントリーで扱う
     (商品ページ=カスケード / その他=#MainContent 一括 / トップは対象外)。

   prefers-reduced-motion: reduce / JS無効時は通常遷移。
   ===================================================================== */
(function () {
  var doc = document;
  var root = doc.documentElement;

  var WIPE_MS = 560; // ワイプ1枚ぶん
  var HOLD_MS = 260; // テーマカラーが覆い切ってから base が動き出すまでの「ため」
  var FALLBACK = '#cccccc';
  var PRODUCT_ENTRY_REVEAL_AT_KEY = 'bkProductEntryRevealAt';
  var PRODUCT_ENTRY_POST_MASK_DELAY_MS = 1700;
  var MOUSE_STALKER_POINT_KEY = 'bkMouseStalkerPoint';

  var reduceMotion = false;
  try {
    reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* ヘッダーを遷移中も残す(覆わない)ためのクラス。CSS は top.css の
     html.bk-pt-keep-header .section-header(ワイプより前面へ)を参照。
     旧ページのヘッダーと新ページのヘッダーは同位置・同見た目なので、
     ワイプで中身だけが切り替わり「ヘッダーは置きっぱなし」に見える。 */
  var KEEP_HEADER_CLASS = 'bk-pt-keep-header';

  /* 遷移先がトップ(/ もしくは /en 等のロケールルート)か。
     トップは KV 上でヘッダーを隠す設計(is-over-hero)なので、残したヘッダーが
     到着時に「パッと消える」より、ワイプで自然に持ち去るほうが滑らか。 */
  function isTopHref(href) {
    try {
      var u = new URL(href, window.location.href);
      return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  /* ヘッダーを残せる遷移か。
     ・全画面メニュー(.bk-menu)発のリンクは、メニュー自身が先に閉じる
       (header-overlay-menu.liquid の click リスナーが本リスナーより先に登録
       されているため、ここに来る時点で bk-menu-open は外れている)。
       → keep-header が効き、メニューの閉じフェード(0.4s)がワイプの上で走る。
     ・下の bk-menu-open ガードは「メニューが開いたまま遷移する」例外時の保険。
       .bk-menu は .section-header のスタッキングコンテキスト内にあり
       「メニューだけ覆ってヘッダーは残す」が不可能なので全面を覆う。 */
  function shouldKeepHeader(href) {
    if (doc.body && doc.body.classList.contains('bk-menu-open')) return false;
    if (isTopHref(href)) return false;
    return true;
  }

  function overlay() {
    return doc.getElementById('bk-pt');
  }
  function layer(name) {
    var o = overlay();
    return o ? o.querySelector('.bk-pt__' + name) : null;
  }

  function rememberProductEntryRevealTiming() {
    try {
      sessionStorage.setItem(
        PRODUCT_ENTRY_REVEAL_AT_KEY,
        String(Date.now() + PRODUCT_ENTRY_POST_MASK_DELAY_MS)
      );
    } catch (e) {}
  }

  function rememberMouseStalkerPoint(e) {
    try {
      sessionStorage.setItem(
        MOUSE_STALKER_POINT_KEY,
        JSON.stringify({ x: e.clientX, y: e.clientY, t: Date.now() })
      );
    } catch (err) {}
  }

  /* ---------------------------------------------------------------
     先読み(prefetch)
     従来はワイプ2枚(560+260+560 ≒ 1380ms)が終わってから location.href
     で初めてネットワーク要求が始まっていた=アニメと通信が直列。
     ホバー時・タップ開始時・クリック直後に遷移先HTMLを先読みしておき、
     アニメーション中に通信を並走させる(見た目・タイミングは不変)。
     Chromium は Speculation Rules、他は <link rel=prefetch>(Safari は
     無視するが害はない)。GETでも副作用のあるURLは対象外。
     --------------------------------------------------------------- */
  var prefetchedHrefs = {};

  /* prefetch してはいけない(副作用がある/意味がない)URLか */
  function isPrefetchUnsafe(a) {
    var path = a.pathname || '';
    return (
      path.indexOf('/checkout') === 0 ||
      path.indexOf('/cart/add') === 0 ||
      path.indexOf('/cart/change') === 0 ||
      path.indexOf('/cart/update') === 0 ||
      path.indexOf('/cart/clear') === 0 ||
      path.indexOf('/account/logout') === 0
    );
  }

  function prefetch(href) {
    if (!href || prefetchedHrefs[href]) return;
    prefetchedHrefs[href] = true;
    try {
      if (
        window.HTMLScriptElement &&
        HTMLScriptElement.supports &&
        HTMLScriptElement.supports('speculationrules')
      ) {
        var s = doc.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ urls: [href] }] });
        doc.head.appendChild(s);
        return;
      }
    } catch (e) {}
    var l = doc.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    doc.head.appendChild(l);
  }

  function prefetchableAnchor(target) {
    var a = target && target.closest && target.closest('a[href]');
    if (!a || isExcludedLink(a) || isPrefetchUnsafe(a)) return null;
    return a;
  }

  /* ホバー(短い滞留で確定)/ タップ開始で先読み。クリック前に通信が始まる */
  var HOVER_PREFETCH_DELAY_MS = 80;
  var hoverPrefetchTimer = 0;

  doc.addEventListener('mouseover', function (e) {
    var a = prefetchableAnchor(e.target);
    if (!a) return;
    clearTimeout(hoverPrefetchTimer);
    hoverPrefetchTimer = setTimeout(function () {
      prefetch(a.href);
    }, HOVER_PREFETCH_DELAY_MS);
  });
  doc.addEventListener('mouseout', function () {
    clearTimeout(hoverPrefetchTimer);
  });
  doc.addEventListener(
    'touchstart',
    function (e) {
      var a = prefetchableAnchor(e.target);
      if (a) prefetch(a.href);
    },
    { passive: true }
  );

  /* transitionend を待つ(保険のタイマー付き) */
  function once(el, prop, ms, cb) {
    var done = false;
    function fire(e) {
      if (done) return;
      if (e && e.propertyName && e.propertyName.indexOf(prop) === -1) return;
      done = true;
      el.removeEventListener('transitionend', fire);
      cb();
    }
    el.addEventListener('transitionend', fire);
    setTimeout(fire, ms + 120);
  }

  /* ---------------------------------------------------------------
     離脱: 商品カードのクリック
     --------------------------------------------------------------- */
  var navigating = false;

  function runExit(href, color) {
    var o = overlay();
    var theme = layer('theme');
    var base = layer('base');
    if (!o || !theme || !base) {
      window.location.href = href;
      return;
    }

    var EASE = 'transform ' + WIPE_MS + 'ms cubic-bezier(0.76, 0, 0.24, 1)';

    root.style.setProperty('--bk-pt-color', color || FALLBACK);

    // ヘッダーは遷移中も残す(例外は shouldKeepHeader を参照)
    if (shouldKeepHeader(href)) root.classList.add(KEEP_HEADER_CLASS);

    o.classList.add('is-active');
    theme.style.transition = 'none';
    theme.style.transform = 'scaleX(0)';
    base.style.transition = 'none';
    base.style.transform = 'scaleX(0)';
    void theme.offsetWidth;

    // 1) テーマカラー面を左→右に
    theme.style.transition = EASE;
    theme.style.transform = 'scaleX(1)';

    once(theme, 'transform', WIPE_MS, function () {
      // テーマカラーが覆い切ったら少し「ため」てから base を動かす
      setTimeout(function () {
        // 2) 基本背景色 #e5e5e5 面を左→右に(テーマカラーの上を覆う)
        base.style.transition = EASE;
        base.style.transform = 'scaleX(1)';
        once(base, 'transform', WIPE_MS, function () {
          // 3) base で覆われたまま商品ページへ遷移
          rememberProductEntryRevealTiming();
          window.location.href = href;
        });
      }, HOLD_MS);
    });
  }

  /* 遷移アニメの対象外(ネイティブ動作に任せる)リンクか判定。
     方針: オプトアウト。サイト内の実遷移リンクは原則すべて対象とし、
     下記に該当するものだけ除外する。個別に切りたい要素には
     [data-bk-no-pt](自身か祖先)を付ける。 */
  function isExcludedLink(a) {
    if (!a) return true;
    // 明示オプトアウト
    if (a.closest('[data-bk-no-pt]')) return true;
    // 別タブ / ダウンロード
    if (a.target && a.target !== '_self') return true;
    if (a.hasAttribute('download')) return true;
    // 自前JSで挙動を奪うUI(カートドロワー / クイックビュー 等)
    if (a.closest('[data-bk-cart-open], [data-bk-quickview]')) return true;
    var href = a.getAttribute('href');
    if (!href) return true;
    if (href.charAt(0) === '#') return true; // ページ内アンカー
    var proto = (a.protocol || '').toLowerCase();
    if (proto === 'mailto:' || proto === 'tel:' || proto === 'javascript:') {
      return true;
    }
    // 別オリジン
    if (a.hostname && a.hostname !== window.location.hostname) return true;
    // 同一ページ(パス+クエリが同じ = 実際には画面遷移しない)
    if (
      a.pathname === window.location.pathname &&
      (a.search || '') === (window.location.search || '')
    ) {
      return true;
    }
    return false;
  }

  doc.addEventListener('click', function (e) {
    if (navigating) return;
    if (e.defaultPrevented) return;
    // 修飾キー / 中ボタン等(新規タブ)は通常動作
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }

    var a = e.target.closest && e.target.closest('a[href]');
    if (isExcludedLink(a)) return;

    if (reduceMotion) return; // 通常遷移に任せる

    // 1枚目の色: 商品カード等は data-bk-theme、無ければ基本アクセントカラー
    var color = a.getAttribute('data-bk-theme') || 'var(--bk-accent)';

    e.preventDefault();
    navigating = true;
    // ホバーを経ないクリック(キーボード操作等)でもワイプ中に通信を並走させる
    if (!isPrefetchUnsafe(a)) prefetch(a.href);
    rememberMouseStalkerPoint(e);
    runExit(a.getAttribute('href'), color);
  });

  /* bfcache 復帰時はオーバーレイを残さない(keep-header の後始末も) */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) {
      navigating = false;
      root.classList.remove(KEEP_HEADER_CLASS);
      var o = overlay();
      if (o) o.classList.remove('is-active');
    }
  });
})();
